import { render } from "./Mocs.vue?vue&type=template&id=39cd669a"
import script from "./Mocs.vue?vue&type=script&lang=js"
export * from "./Mocs.vue?vue&type=script&lang=js"

import "./Mocs.vue?vue&type=style&index=0&id=39cd669a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__